import { render, staticRenderFns } from "./MediaPermissionPage.vue?vue&type=template&id=9d42feee&scoped=true"
import script from "./MediaPermissionPage.vue?vue&type=script&lang=js"
export * from "./MediaPermissionPage.vue?vue&type=script&lang=js"
import style0 from "./MediaPermissionPage.vue?vue&type=style&index=0&id=9d42feee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d42feee",
  null
  
)

export default component.exports